import { NameDto } from '../../Common/Types'

export const ClientSubscriptionType: NameDto[] = [
  { name: 'Market Data', id: 1 },
  { name: 'Platform', id: 2 },
]

export const ClientSubscriptionLevel: NameDto[] = [
  { name: 'Level 1', id: 1 },
  { name: 'Level 2', id: 2 },
]
